import * as go from 'gojs';

export type GoJsOverviewPositionString = 'TopLeft' | 'TopRight' | 'BottomLeft' | 'BottomRight';

export const GoJsOverviewPositionToClass: Record<GoJsOverviewPositionString, string> = {
  TopLeft: 'top-4 left-4',
  TopRight: 'top-4 right-4',
  BottomLeft: 'bottom-4 left-4',
  BottomRight: 'bottom-4 right-4',
};

export const gojsOverview = (diagram: go.Diagram) => {
  const GO = go.GraphObject.make;
  const overview = GO(go.Overview, { observed: diagram, contentAlignment: go.Spot.Center });
  return overview;
};
